import Modal from '@components/Modal'
import { PROFILE_NAME_TITLE } from '@lib/profileName'
import React from 'react'
import ProfileNameForm from './ProfileNameForm'
import { NameIntro } from './ProfileNameModal.styles'

interface ProfileNameModalProps {
	isOpen: boolean
	initialFirstName: string
	initialLastName: string
}

const stayOpen = () => {}

/**
 * The profile-name step over the app: it can't be closed or skipped, and goes
 * away once my profile carries both names. Mirrors the apps' post-login screen.
 */
const ProfileNameModal: React.FC<ProfileNameModalProps> = ({ isOpen, initialFirstName, initialLastName }) => (
	<Modal
		isOpen={isOpen}
		onClose={stayOpen}
		title={PROFILE_NAME_TITLE}
		showCloseButton={false}
		closeOnBackdropClick={false}
		size="small"
	>
		<NameIntro>Your trip mates will see this name.</NameIntro>
		<ProfileNameForm idPrefix="profile-name" initialFirstName={initialFirstName} initialLastName={initialLastName} />
	</Modal>
)

export default ProfileNameModal
